import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { NATIONAL_DATA_ACTION_TYPE, NationalDataAction } from "./national-data.action";
import { NationalDataService } from "./national-data.service";

/**
 * @deprecated [fabric-deprecated] - use NationalDataService from app-account instead
 */
@Injectable()
export class NationalDataEffect {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetCountryCitiesNationalData) instead
	 */
	getBirthCities$ = createEffect(() =>
		this.actions$.pipe(
			ofType(NATIONAL_DATA_ACTION_TYPE.getBirthCities),
			switchMap(() =>
				this.nationalDataService.getCountryCities().pipe(
					map((countryWithCities) => this.nationalDataAction.getBirthCitiesSuccess(countryWithCities.cities)),
					catchError((error: AppError) => of(this.nationalDataAction.getBirthCitiesFail(error)))
				)
			)
		)
	);

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetCountryByTaxCodeNationalData) instead
	 */
	getCountryByTaxCode$ = createEffect(() =>
		this.actions$.pipe(
			ofType(NATIONAL_DATA_ACTION_TYPE.getCountryByTaxCode),
			map((x: ActionWithPayload<string>) => x.payload),
			switchMap((taxCodeFragment) =>
				this.nationalDataService.getCountryByTaxCode(taxCodeFragment).pipe(
					map((response) => this.nationalDataAction.getCountryByTaxCodeSuccess(response)),
					catchError((error: AppError) => of(this.nationalDataAction.getCountryByTaxCodeFail(error)))
				)
			)
		)
	);

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.GetTaxCodeByCountryNationalData) instead
	 */
	getTaxCodeByCountry$ = createEffect(() =>
		this.actions$.pipe(
			ofType(NATIONAL_DATA_ACTION_TYPE.getTaxCodeByCountry),
			map((x: ActionWithPayload<string>) => x.payload),
			switchMap((countryCode) =>
				this.nationalDataService.getTaxCodeByCountry(countryCode).pipe(
					map((response) => this.nationalDataAction.getTaxCodeByCountrySuccess(response)),
					catchError((error: AppError) => of(this.nationalDataAction.getTaxCodeByCountryFail(error)))
				)
			)
		)
	);

	constructor(
		private actions$: Actions,
		private nationalDataAction: NationalDataAction,
		private nationalDataService: NationalDataService
	) {}
}
